// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"261":"d258fa0e","375":"ba4c84eb","433":"a0d9a16f","490":"44feee2b","635":"335812f5","765":"2552785d","787":"dd2aaba0","888":"34a8334b","978":"f87a9001"}[chunkId] + ".chunk.js";
};